import { Stack, Text } from '@fluentui/react';

import { ConfirmDialog } from '../../../components/BaseDialog/BaseDialog';
import { navigate } from '../../../utils/utils';

type BookTimeDialogProps = {
  onDismiss: () => void;
  hidden: boolean;
  url?: string;
};

export function BookTimeDialog({ hidden, url = '', onDismiss }: BookTimeDialogProps) {
  return (
    <ConfirmDialog
      data-test="book-time-dialog"
      onDismiss={onDismiss}
      content={
        <Stack tokens={{ childrenGap: 10 }}>
          <Text>It looks like you want to be able to do one of the following:</Text>
          <ul>
            <li>Use non-public data in apps or AI engines</li>
            <li>Upload your own app</li>
            <li>Collaborate with your colleagues on building and deploying models</li>
          </ul>
          <Text>These features require a single tenant environment to be created for your organization.</Text>
          <Text>Please schedule a call with one of our Activation Specialists to get started.</Text>
        </Stack>
      }
      hidden={hidden}
      title={'You may need a Managed Cloud...'}
      onConfirm={() => navigate(url)}
      confirmationButtonText="Book a time"
      suppressDismissalButton
    ></ConfirmDialog>
  );
}
